import { type ReactNode } from "react";
import { Context } from "./context";
import { type SyncManager } from "./manager";
import { useTestSyncModules } from "./test";

export function SyncManagerProvider({
  manager,
  children,
}: {
  manager: SyncManager;
  children: ReactNode;
}) {
  useTestSyncModules(manager);

  return <Context.Provider value={manager}>{children}</Context.Provider>;
}
